import { type ApolloLink, CombinedGraphQLErrors } from '@apollo/client';

const UNAUTHENTICATED_CODE = 'UNAUTHENTICATED';

// The BFF auth middleware rejects requests with these messages and no
// extensions.code, so the code alone cannot identify them.
const UNAUTHENTICATED_MESSAGES = ['missing authorization header', 'token is not active'];

const isUnauthenticatedError = (error: {
  message?: string;
  extensions?: Record<string, unknown>;
}): boolean =>
  error.extensions?.['code'] === UNAUTHENTICATED_CODE ||
  UNAUTHENTICATED_MESSAGES.includes(error.message ?? '');

const hasUnauthenticatedError = (error: unknown): boolean => {
  if (!CombinedGraphQLErrors.is(error)) {
    return false;
  }

  return error.errors.some(isUnauthenticatedError);
};

const hasUnauthenticatedResult = (result: ApolloLink.Result): boolean =>
  result.errors?.some(isUnauthenticatedError) ?? false;

export { hasUnauthenticatedError, hasUnauthenticatedResult, isUnauthenticatedError };
